<template>
    <a-layout class="provisioning-layout">
        <a-row>
            <ProvisioningHeader />
            <ProvisioningTitle>
                <template #title>
                    <h3 class="title_font_Weight">輸入驗證碼</h3>
                </template>
                <template #subTitle>
                    <p class="sub_title_width">
                        已寄送OTP驗證碼至  <span>{{hiddenPartPhoneNumber}}</span>
                    </p>
                </template>
            </ProvisioningTitle>
            <ProvisioningVerificationCode />
            <ProvisioningVerifyButton  @responseStatus="getResponseMsg" @loading="isLoadingChanged"/>
            <ModalApiResultMsg
            :visible="responseMsgObj.visible" 
            :title="responseMsgObj.title" 
            :okText="responseMsgObj.okText"
            :cancelText="responseMsgObj.cancelText"
            :msgClass="responseMsgObj.msgClass"
            :okCallback="responseMsgObj.msgClass === 'msg_error_modal' ? callPhoneNumber : hideModal" 
            :cancelCallback="hideModal">
            <p>{{responseMsgObj.detailText}}</p>
            </ModalApiResultMsg>
            <ProvisioningLoading :status="isLoading" text="驗證中，請稍候"/>
        </a-row>
    </a-layout>
</template>

<script>
    import { mapGetters } from 'vuex';
    import ProvisioningHeader from "../../components/deviceProvision/ProvisioningHeader.vue";
    import ProvisioningTitle from "../../components/deviceProvision/ProvisioningTitle.vue";
    import ProvisioningVerificationCode from "../../components/deviceProvision/ProvisioningVerificationCode.vue";
    import ProvisioningVerifyButton from "../../components/deviceProvision/ProvisioningVerifyButton.vue";
    import ModalApiResultMsg from "../../components/modal/ModalApiResultMsg.vue";
    import { mixinModalMethods } from "../../utils/mixins";
    import ProvisioningLoading from "@/components/deviceProvision/ProvisioningLoading.vue";

    export default {
        name: 'ProvisioningVerificationCodeContainer',
        components: {
          ProvisioningLoading,
            ProvisioningHeader,
            ProvisioningTitle, 
            ProvisioningVerificationCode, 
            ProvisioningVerifyButton,
            ModalApiResultMsg,
        },
        mixins: [ mixinModalMethods ],
        computed: {
            ...mapGetters('identidyInfo', ['hiddenPartPhoneNumber']),
        },
        data(){
          return{
            isLoading: false,
          }
        },
        methods:{
          isLoadingChanged(status) {
            this.isLoading = status;
          }
        }
    }
</script>